import axios from "axios";
import { getHeaders } from "../utils/main";
import endpoints from "./endpoints";

export const fetchProductSubCategoryApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.ProductSubCategoryFetch,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

export const createProductSubCategoryApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.ProductSubCategoryCreate,
    method: "post",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

export const deleteProductSubCategoryApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.ProductSubCategoryDelete,
    method: "delete",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

export const updateProductSubCategoryApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.ProductSubCategoryUpdate,
    method: "patch",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

export const getProductSubCategoryByIdApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.ProductSubCategoryFetchById,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};
